import Localizer from "@/localization/Localizer";
import CypressDropdownHelper from "@/helpers/CypressDropdownHelper";
import { pageData } from "../../../helpers/CypressHelper";

describe('Desktop - Admin Product Details Preferred model tests', () => {

    beforeEach(() => {
        cy.useSharedAdminUserSession();

        cy.intercept('POST', 'api/Product/GetRelatedProducts', { fixture: 'product_takeuchi_tb210r_related.json' }).as('data');
    });

    it('Opens ProductDetails and checks if preferred model dropdown not exists', () => {

        cy.intercept('POST', 'api/Product/ProductData', { fixture: 'product_takeuchi_tb210r.json' }).as('data');

        cy.intercept('POST', 'api/Product/GetProductAvailability', { fixture: 'product_takeuchi_tb210r_availability.json' }).as('data');

        cy.visit('tuote/mock-url');

        pageData().rent.product.productPreferredModelDropdown().should('not.exist');

    });

    it('Opens ProductDetails and checks if preferred model dropdown exists', () => {

        cy.intercept('POST', 'api/Product/ProductData', { fixture: 'product_takeuchi_tb210r.json' }).as('data');

        cy.fixture('product_takeuchi_tb210r_availability.json').then((body) => {

            body.value.selectableModels.push("Minigravemaskine 2,0 tons");

            // Intercept the request and return the modified data
            cy.intercept('POST', 'api/Product/GetProductAvailability', body).as('data');
        });

        cy.visit('tuote/mock-url');

        pageData().rent.product.productPreferredModelDropdown().should('exist');

        var options = [Localizer.productDetailsAnyModel, 'Minigravemaskine 1,0 tons', 'Minigravemaskine 2,0 tons'];
        CypressDropdownHelper.validateDropdownOptions('#productPreferredModelDropdown', options);
    });

    it('Opens ProductDetails and checks if preferred model dropdown not exists as the selection is prevented', () => {

        cy.fixture('product_takeuchi_tb210r.json').then((body) => {

            body.value.product.product.preventModelSelection = true;
            cy.intercept('POST', 'api/Product/ProductData', body).as('data');
        });

        cy.fixture('product_takeuchi_tb210r_availability.json').then((body) => {

            body.value.selectableModels.push("Minigravemaskine 2,0 tons");
            cy.intercept('POST', 'api/Product/GetProductAvailability', body).as('data');
        });

        cy.visit('tuote/mock-url');

        pageData().rent.product.productPreferredModelDropdown().should('not.exist');
    });

});